import { useSyncExternalStore } from "react";
import { categoryStore } from "./index";
import type { Category } from "./types";

function getSnapshot(): Category[] {
  return categoryStore.list();
}

const SERVER_SNAPSHOT: Category[] = [];
function getServerSnapshot(): Category[] {
  return SERVER_SNAPSHOT;
}

function subscribe(listener: () => void): () => void {
  return categoryStore.subscribe(listener);
}

export interface UseCategoriesResult {
  categories: Category[];
  getById(id: string): Category | undefined;
  refresh(): Promise<void>;
}

export function useCategories(): UseCategoriesResult {
  const categories = useSyncExternalStore(
    subscribe,
    getSnapshot,
    getServerSnapshot,
  );
  return {
    categories,
    getById: (id: string) => categories.find((c) => c.id === id),
    refresh: () => categoryStore.refresh(),
  };
}
